module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="js-team-filed-bench view-player-bench">\n	<div class="team-filed-bench-sub-header">Bench</div>\n	<div class="bench-players">\n		';
  _.size(positions_by_id) && _.each(lineup.bench, function(player, index){ 
__p+='\n			';
 if(player.id){ 
__p+='\n				<div class="player-cell '+
((__t=( player.substitute_class_name ))==null?'':_.escape(__t))+
' '+
((__t=( player.is_dnp && player.is_locked ? 'is-dnp' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.is_not_counted && player.is_locked ? 'is-not-counted' : '' ))==null?'':_.escape(__t))+
'" data-player-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'" data-position-id="bench">\n					<div class="player-cell-inner">\n						<div class="bench-position-type '+
((__t=( index < 4 ? 'interchange' : 'emergencies' ))==null?'':_.escape(__t))+
'">\n							<div class="bench-position-label">\n								<span>'+
((__t=( index < 4 ? 'INT' : 'EMG' ))==null?'':_.escape(__t))+
'</span>\n								<i class="bench-index">'+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'</i>\n							</div>\n						</div>\n						<figure>\n							<picture>\n								<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n								<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n									 alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n							</picture>\n						</figure>\n						<div class="player-info">\n							<div class="player-name">\n								<i class="player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n								<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n							</div>\n							';
 if(is_coach_enabled){ 
__p+='\n							<div class="player-stats-coach">\n								';
 if(has_assistant_coach) { 
__p+='\n								<div class="proj-score">\n									PROJ.<b>'+
((__t=( player.stats.proj_score ))==null?'':_.escape(__t))+
'</b>\n									&nbsp;\n									BE.<b>'+
((__t=( player.stats.break_even ))==null?'':_.escape(__t))+
'</b>\n								</div>\n								';
 if(player.stats.bye_round_id){ 
__p+='\n									<div class="bye-rd">BYE RD. <span>'+
((__t=( player.stats.bye_round_id ))==null?'':_.escape(__t))+
'</span></div>\n								';
 } 
__p+='\n								';
 } else { 
__p+='\n									<!-- User has no assistant coach but trigger to show coach data -->\n									<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n								';
 } 
__p+='\n							</div>\n							';
 } else { 
__p+='\n							<div>\n								<span class="player-squad-name">\n									'+
((__t=( player.squad_name ))==null?'':_.escape(__t))+
'\n								</span>\n								<span class="player-positions">\n									| '+
((__t=( player.position_names.join(' | ') ))==null?'':_.escape(__t))+
' | '+
((__t=( _.currencyFormat(player.cost, '') ))==null?'':_.escape(__t))+
'\n								</span>\n							</div>\n							';
 } 
__p+='\n						</div>\n						<div class="bench-points-last-round">\n							<span class="'+
((__t=( player.is_playing_now && player.stats.points_last_round ? 'is-scoring-now' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( player.stats.points_last_round ))==null?'':_.escape(__t))+
'</span>\n						</div>\n					</div>\n				</div>\n			';
 }else { 
__p+='\n				<div class="player-cell-empty" data-position-id="bench">\n					<div class="bench-position-type '+
((__t=( index < 4 ? 'interchange' : 'emergencies' ))==null?'':_.escape(__t))+
'">\n						<div class="bench-position-label">\n							<span>'+
((__t=( index < 4 ? 'INT' : 'EMG' ))==null?'':_.escape(__t))+
'</span>\n							<i class="bench-index">'+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'</i>\n						</div>\n					</div>\n					<div class="player-cell-empty-text">\n						<span class="empty-player-cell-position">\n							This item is empty\n						</span>\n					</div>\n				</div>\n			';
 } 
__p+='\n		';
 }) 
__p+='\n	</div>\n</section>';
}
return __p;
};
